import shareActionButton from './share-action-button'
import useCasesContainer from './use-cases-container'

export default {
    useCases: useCasesContainer,
    website: 'Visit website',
    megatrends: 'Mega-trends',
    macrotrends: 'Macro-trends',
    industries: 'Industries',
    innovationTypes: 'Innovation types',
    related: 'Related micro-trends',
    author: 'Author',
    initiator: 'Initiator',
    noTranslation: 'no English translation available',
    marker: 'Company-micro-trend',
    sdgs: 'SDGs',
    confirmation: {
        title: 'Do you want to save the changes to the Micro-trend?',
        cancel: 'Cancel',
        no: 'Do not save',
        yes: 'Save'
    },
    shareActionButton
}
